import { Router } from 'itty-router';
import { completionController } from '../../controllers/completion';

export default (base: string) => {
    const router = Router({ base });
    
    // POST /v1/completion - Main completion endpoint
    router.post('/', completionController.handleRequest);
    
    // POST /v1/completion/stream - Explicit streaming endpoint
    router.post('/stream', completionController.handleStream);
    
    return { base, router };
};


